import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ToastContext } from '../App';

const RegisterPage: React.FC = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [countdown, setCountdown] = useState(5);
  const { register } = useAuth();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const { showToast } = React.useContext(ToastContext);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccessMessage('');

    if (password !== confirmPassword) {
      setError('As passwords não coincidem');
      showToast('As passwords não coincidem', 'error');
      setLoading(false);
      return;
    }

    if (password.length < 6) {
      setError('A password deve ter pelo menos 6 caracteres');
      showToast('A password deve ter pelo menos 6 caracteres', 'error');
      setLoading(false);
      return;
    }

    const result = await register(name, email, password);
    
    if (result.success) {
      setSuccessMessage(result.message || 'Registo realizado com sucesso!');
      showToast('Registo realizado com sucesso!', 'success');
      
      // Iniciar countdown para redirecionar
      let count = 5;
      const timer = setInterval(() => {
        count--;
        setCountdown(count);
        if (count === 0) {
          clearInterval(timer);
          navigate('/login');
        }
      }, 1000);
    } else {
      setError(result.message || 'Erro no registo');
      showToast(result.message || 'Erro no registo', 'error');
    }
    
    setLoading(false);
  };

  if (successMessage) {
    return (
      <div className="container py-4">
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-4">
            <div className="card shadow">
              <div className="card-header" style={{backgroundColor: '#a2449c', color: 'white', textAlign: 'center'}}>
                <h4 className="mb-0">
                  <i className="fas fa-check-circle me-2"></i>
                  Sucesso!
                </h4>
              </div>
              <div className="card-body text-center">
                <div style={{backgroundColor: '#e9d6ef', color: '#4a235a', border: '1px solid #a2449c', borderRadius: 8, padding: 16, marginBottom: 16, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                  <i className="fas fa-check-circle me-2" style={{color: '#a2449c', fontSize: 22}}></i>
                  {successMessage}
                </div>
                <p className="text-muted">
                  A ser redirecionado para a página de login em {countdown} segundos...
                </p>
                <button 
                  className="btn w-100" 
                  style={{backgroundColor: '#a2449c', color: 'white'}}
                  onClick={() => navigate('/login')}
                >
                  Ir para Login
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container py-4">
      <div className="row justify-content-center">
        <div className="col-md-6 col-lg-4">
          <div className="card shadow">
            <div className="card-header" style={{backgroundColor: '#a2449c'}}>
              <h4 className="mb-0 text-white text-center">
                <i className="fas fa-user-plus me-2"></i>
                Registar
              </h4>
            </div>
            <div className="card-body">
              {/* Removido bloco de erro direto, manter apenas Toast */}

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="name" className="form-label">Nome</label>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="password" className="form-label">Password</label>
                  <div className="input-group">
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control"
                      id="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                      minLength={6}
                    />
                    <button
                      className="btn btn-outline-secondary"
                      type="button"
                      tabIndex={-1}
                      onClick={() => setShowPassword((v) => !v)}
                      title={showPassword ? 'Esconder password' : 'Ver password'}
                    >
                      <i className={`fas fa-${showPassword ? 'eye-slash' : 'eye'}`}></i>
                    </button>
                  </div>
                  <div className="form-text">A password deve ter pelo menos 6 caracteres</div>
                </div>
                <div className="mb-3">
                  <label htmlFor="confirmPassword" className="form-label">Confirmar Password</label>
                  <div className="input-group">
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      className="form-control"
                      id="confirmPassword"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      required
                    />
                    <button
                      className="btn btn-outline-secondary"
                      type="button"
                      tabIndex={-1}
                      onClick={() => setShowConfirmPassword((v) => !v)}
                      title={showConfirmPassword ? 'Esconder password' : 'Ver password'}
                    >
                      <i className={`fas fa-${showConfirmPassword ? 'eye-slash' : 'eye'}`}></i>
                    </button>
                  </div>
                </div>
                <button
                  type="submit"
                  className="btn w-100"
                  style={{backgroundColor: '#a2449c', borderColor: '#a2449c', color: 'white'}}
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      A registar...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-user-plus me-2"></i>
                      Registar
                    </>
                  )}
                </button>
              </form>

              <div className="text-center mt-3">
                <p className="mb-0">
                  Já tem conta?{' '}
                  <Link to="/login" className="text-decoration-none" style={{color: '#a2449c'}}>
                    Entrar
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage; 